import { z } from 'zod';

const COMPONENT_FOCAL_LENGTHS_ANALYSIS = {
  label: 'Component Focal Lengths', group: 'system',
  description: 'Focal lengths and diameters of each refractive component.',
  settingsSchema: z.strictObject({}), parameters: [],
  coverage: 'Components are groups of refracting surfaces surrounded by air. Values are in lens units.',
} as const;
export default COMPONENT_FOCAL_LENGTHS_ANALYSIS;
